import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const HistoryContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${barnesTheme.spacing.sectionGap};
  margin-top: ${barnesTheme.spacing.smallGap};

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: ${barnesTheme.spacing.sectionGap} !important;
    margin-top: ${barnesTheme.spacing.smallGap} !important;
  }
`

export const SubtitleText = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.body};
  color: ${barnesTheme.colors.textLight};
  margin-top: 2px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.body} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TableSection = styled.div`
  display: flex;
  flex-direction: column;

  @media print {
    display: flex !important;
    flex-direction: column !important;
  }
`

export const TableTitle = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: 13px;
  color: ${barnesTheme.colors.accent};
  margin-bottom: ${barnesTheme.spacing.smallGap};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: 13px !important;
    color: ${barnesTheme.colors.accent} !important;
    margin-bottom: ${barnesTheme.spacing.smallGap} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
  }
`

export const TableHeaderRow = styled.div`
  display: flex;
  height: 28px;
  align-items: center;
  background: transparent;
  border-bottom: 1px solid ${barnesTheme.colors.primary};

  @media print {
    display: flex !important;
    height: 28px !important;
    align-items: center !important;
    background: transparent !important;
    border-bottom: 1px solid ${barnesTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TableHeaderCell = styled.div<{ $width?: string; $align?: string }>`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: ${barnesTheme.fontSizes.small};
  color: ${barnesTheme.colors.textLight};
  width: ${({ $width }) => $width || 'auto'};
  flex: ${({ $width }) => ($width ? 'none' : '1')};
  padding: 0 6px;
  text-align: ${({ $align }) => $align || 'left'};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: ${barnesTheme.fontSizes.small} !important;
    color: ${barnesTheme.colors.textLight} !important;
    width: ${({ $width }) => $width || 'auto'} !important;
    flex: ${({ $width }) => ($width ? 'none' : '1')} !important;
    padding: 0 6px !important;
    text-align: ${({ $align }) => $align || 'left'} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TableDataRow = styled.div<{ $even: boolean }>`
  display: flex;
  height: 32px;
  align-items: center;
  background: ${barnesTheme.colors.white};
  border-bottom: 1px solid ${barnesTheme.colors.border};

  @media print {
    display: flex !important;
    height: 32px !important;
    align-items: center !important;
    background: ${barnesTheme.colors.white} !important;
    border-bottom: 1px solid ${barnesTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TableDataCell = styled.div<{
  $width?: string
  $align?: string
  $bold?: boolean
}>`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${({ $bold }) =>
    $bold ? barnesTheme.fontWeights.bold : barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.body};
  color: ${({ $bold }) =>
    $bold ? barnesTheme.colors.text : barnesTheme.colors.text};
  width: ${({ $width }) => $width || 'auto'};
  flex: ${({ $width }) => ($width ? 'none' : '1')};
  padding: 0 6px;
  text-align: ${({ $align }) => $align || 'left'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${({ $bold }) =>
      $bold
        ? barnesTheme.fontWeights.bold
        : barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.body} !important;
    color: ${({ $bold }) =>
      $bold ? barnesTheme.colors.text : barnesTheme.colors.text} !important;
    width: ${({ $width }) => $width || 'auto'} !important;
    flex: ${({ $width }) => ($width ? 'none' : '1')} !important;
    padding: 0 6px !important;
    text-align: ${({ $align }) => $align || 'left'} !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EmptyMessage = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.body};
  color: ${barnesTheme.colors.textLight};
  padding: 12px 6px;
  font-style: italic;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.body} !important;
    color: ${barnesTheme.colors.textLight} !important;
    padding: 12px 6px !important;
    font-style: italic !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SummarySection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: ${barnesTheme.spacing.contentGap};

  @media print {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    margin-top: ${barnesTheme.spacing.contentGap} !important;
  }
`

export const SummaryLabel = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.body};
  color: ${barnesTheme.colors.textLight};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.body} !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SummaryValue = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: 24px;
  color: ${barnesTheme.colors.text};
  line-height: 1.2;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: 24px !important;
    color: ${barnesTheme.colors.text} !important;
    line-height: 1.2 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SummarySubtext = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.body};
  color: ${barnesTheme.colors.textLight};
  margin-top: 4px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.body} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 4px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
